<template>
  <div class="listItem">
    <div v-if="data.length > 0">
      <div class="flex between list-item" v-for="(item, i) in data" :key="i" @click="onRoute(item.id)">
        <div>
          <div class="headImg-border">
            <img :src="item.photoUrl" class="headImg" v-if="item.photoUrl && item.photoUrl != ''">
            <img src="../assets/photo-normal.png" class="headImg" v-else>
          </div>
          <div class="other clr-white fz-12">
            <span>{{ item.consultantDictRelationList | filterList }}</span>
          </div>
        </div>
        <div>
          <div class="flex between">
            <div class="flex align">
              <span class="clr-black fz-16">{{ item.name }}</span>
              <img src="../assets/woman.svg" class="img-sex" v-if="item.gender == 1">
              <img src="../assets/man.svg" class="img-sex" v-else>
            </div>
            <span class="clr-red fz-14">{{ item.price }}元/次</span>
          </div>
          <div class="flex between clr-simple fz-12 margin-12"><span>咨询经验<span class="clr-cyan">{{ item.consultHour
                }}+小时</span></span>
            <div>
              <div>{{ item.city }}<span v-if="item.county">·</span>{{ item.county }}</div>
              <div v-if="item.secondCity">{{ item.secondCity }}<span v-if="item.secondCounty">·</span>{{
                item.secondCounty }}</div>
            </div>
          </div>
          <div class="intro" v-html="item.profile"></div>

          <div class="clr-simple fz-12 tag-list flex wrap"><span v-for="(label, n) in item.consultantDictRelationList"
              :key="n"><span class="tag" v-if="label.dictCode == 'CONSULT_TOPIC'">{{ label.dictDetailDescription
                }}</span></span></div>
        </div>
      </div>
    </div>
    <div v-else>
      <img src="../assets/none.svg" class="list-none">
      <div class="list-text">未找到符合条件的咨询师</div>
      <div class="list-text">请试试更换上方筛选条件</div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'ListItem',
  props: {
    data: {
      type: Array,
      default: function () {
        return []
      }
    },
  },
  data() {
    return {
      flagType: false
    }
  },
  filters: {
    filterList: function (val) {
      const list1 = val.filter(item => {
        return item && (item.dictDetailDescription == '面询')
      })
      const list2 = val.filter(item => {
        return item && (item.dictDetailDescription == '视频')
      })
      let value = ''
      if (list1.length == 1 && list2.length == 0) {
        value = '面询'
      } else if (list1.length == 0 && list2.length == 1) {
        value = '视频'
      } else if (list1.length == 1 && list2.length == 1) {
        value = '面询和视频'
      }
      return value
    }
  },
  methods: {
    onRoute(id) {
      this.$router.push({
        path: '/detail',
        query: {
          id: id
        }
      });
    }
  },

};

</script>
<style lang="stylus">
  @import '../stylus/components/listItem.styl'

</style>



// WEBPACK FOOTER //
// src/components/ListItem.vue